// extracted by css-extract-rspack-plugin
export default {"reference":"aQDUaO","reference-full-width":"aMamEM","referenceFullWidth":"aMamEM"};